import { createAction } from '@reduxjs/toolkit';

export const CURRENT_CUSTOMER_ACTION_TYPES = {
  SET_CURRENT_CUSTOMER: 'SET_CURRENT_CUSTOMER',
};

export const setCurrentCustomer = createAction<string>(CURRENT_CUSTOMER_ACTION_TYPES.SET_CURRENT_CUSTOMER);
